import { Injectable } from '@angular/core';
import { SnapshotResponseDto } from '@cloud-twin-v2/generated/simulation.generated.client';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModelVersionSharedService {
  private snapshotsSelection = new BehaviorSubject<SnapshotResponseDto[]>([]);
  selection$ = this.snapshotsSelection.asObservable();

  private selectedInstance = new BehaviorSubject<string>(null);
  selectionInstance$ = this.selectedInstance.asObservable();

  private instanceToDelete = new BehaviorSubject<string>(null);
  instanceToDelete$ = this.instanceToDelete.asObservable();

  private snapshotsIdsToDelete = new BehaviorSubject<string[]>(null);
  snapshotsIdsToDelete$ = this.snapshotsIdsToDelete.asObservable();

  private scenariosRemoved = new BehaviorSubject<boolean>(null);
  scenariosRemoved$ = this.scenariosRemoved.asObservable();

  private instanceToUpdate = new BehaviorSubject<{ instanceId: string; snapshotIds: string[] }>(
    null
  );
  instanceToUpdate$ = this.instanceToUpdate.asObservable();

  private snapshotToUpdate = new BehaviorSubject<{
    instanceId;
    snapshotId: string;
    scenarioIds: string[];
  }>(null);
  snapshotToUpdate$ = this.snapshotToUpdate.asObservable();

  updateSelect(selection: SnapshotResponseDto[]) {
    this.snapshotsSelection.next(selection);
  }

  updateSelectInstance(instanceId: string) {
    this.selectedInstance.next(instanceId);
  }

  removeInstance(instanceId: string) {
    this.instanceToDelete.next(instanceId);
  }

  removeSnapshots(scenarioIds: string[]) {
    this.snapshotsIdsToDelete.next(scenarioIds);
  }

  removeScenarios(success: boolean): void {
    this.scenariosRemoved.next(success);
  }

  updateSnapshotsOfInstance(instanceId: string, snapshotIds: string[]) {
    this.instanceToUpdate.next({ instanceId, snapshotIds });
  }

  updateScenariosOfSnapshots(instanceId, snapshotId: string, scenarioIds: string[]) {
    this.snapshotToUpdate.next({ instanceId, snapshotId, scenarioIds });
  }
}
